<template>
  <div class="display-modal">
    <h3>Set dates for this book</h3>
    <form class="pure-form" v-on:submit.prevent="onSubmit">
      <p><label>Do you own this book?<input type="checkbox" v-model="owned" /></label></p>
      <p>
        <label>
          Bought on:
          <input v-model="bought_at" type="date" />
        </label>
      </p>
      <p>
        <label>
          Started on:
          <input v-model="started_at" type="date" />
        </label>
      </p>
      <p>
        <label>
          Finished on:
          <input v-model="finished_at" type="date" />
        </label>
      </p>
      <p><label>Do you currently possess this book?<input type="checkbox" v-model="possessed" /></label></p>
      <button @click=deleteBook>Remove this book from your collection</button>
      <p><button>Save</button>
            <button @click="$emit('close')">Close</button></p>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";

export default {
  name: "bookDatePicker",
  data() {
    return {
      token: this.$cookies.get("user"),
      book: {},
      owned: true,
      possessed: true,
      bought_at: "",
      started_at: "",
      finished_at: ""
    };
  },
  props: ["publication"],
  async mounted() {
    // await this.getUser();
    await this.getBook();
  },
  methods: {
    async getBook() {
      if (this.publication.bookId) {
        axios
          .get(`/book/${this.publication.bookId}`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then(response => {
            this.book = response.data;
            if (this.book.bought_at) {
              this.bought_at = this.book.bought_at.split("T")[0];
            }
            if (this.book.started_at) {
              this.started_at = this.book.started_at.split("T")[0];
            }
            if (this.book.finished_at) {
              this.finished_at = this.book.finished_at.split("T")[0];
            }
            this.owned = !!this.book.owned;
            this.possessed = !!this.book.possessed;
          });
      }
    },
    onSubmit() {
      return axios.put(
        `/book/${this.publication.bookId}`,
        {
          bought_at: this.bought_at || null,
          started_at: this.started_at || null,
          finished_at: this.finished_at || null,
          owned: this.owned ? 1 : 0,
          possessed: this.possessed ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        }
      );
    },
    deleteBook() {
      const approval = confirm("really delete this book?");
      if(approval) {
        return axios.delete(
          `/book/${this.publication.bookId}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then(() => {
          this.$eventHub.$emit('refresh-shelves');
          this.$emit('close');
        });
      }
    }
  }
};
</script>
